import React, { useState, useRef } from "react";

//#region Material Components
import { withStyles } from "@material-ui/styles";
import MuiDialog from "@material-ui/core/Dialog";
import { CircularProgress } from "@material-ui/core";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CropIcon from "@material-ui/icons/Crop";
import ShareIcon from "@material-ui/icons/Share";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
//#endregion

//#region Internal
import { getReportsDetails, getImageUrlR, getImageUrlRProd, cropPage, getAchievementVideoDetail, getLectureSectionDetail, removeContent } from "../../api/FeedBacks";
import { useEffect } from "react";
import {
  deleteQuestion,
  deleteVideo,
  deleteQuestionAdmin,
  deleteVideoAdmin,
  getEditorialSystemId,
} from "../../api/BookSectionCrop";
import { toast } from "react-toastify";
import EditorialSystemId from "../../enums/EditorialSystemId";
import ReportContentType from "../../enums/ReportContentType";
import { FB, fmtDate, cleanReasons } from "../../assets/feedbackTheme";
//#endregion

const Dialog = withStyles({
  paper: { borderRadius: 12 },
  paperWidthSm: { maxWidth: 960, minWidth: 320 },
})(MuiDialog);

//#region Buttons
const baseBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  fontSize: 13,
  fontWeight: 500,
  padding: "8px 12px",
  borderRadius: 8,
  cursor: "pointer",
  border: `1px solid ${FB.borderStrong}`,
  background: FB.surface,
  color: FB.text,
};
const primaryBtn = {
  ...baseBtn,
  background: FB.doneSoft,
  color: FB.done,
  border: `1px solid ${FB.doneBorder}`,
};
const dangerBtn = {
  ...baseBtn,
  color: FB.danger,
  border: `1px solid ${FB.dangerBorder}`,
};
const ansPill = (isCorrect, isPending) => ({
  width: 42,
  height: 42,
  borderRadius: 8,
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
  background: isCorrect ? FB.accentSoft : FB.surface,
  color: isCorrect ? FB.accent : FB.text,
  border: isPending
    ? `2px solid ${FB.accent}`
    : `1px solid ${isCorrect ? FB.accentBorder : FB.borderStrong}`,
});
//#endregion

let option = "";
function ReportDialog(props) {
  const [details, setDetails] = useState([]);
  const [cropIdDetails, setCropIdDetails] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [answerSubmitting, setAnswerSubmitting] = useState(false);
  // Optimistic display of the just-changed answer. The grid row / cropIdDetails the
  // dialog opened with stays as-is after a change, so this overrides what `correct`
  // marks until the dialog is closed.
  const [answerOverride, setAnswerOverride] = useState(null);
  const [imageUrl, setImageUrl] = useState({
    mainImage: null,
    imageParts: [],
    RowStatus: false,
  });
  const [prodImageUrl, setProdImageUrl] = useState({
    mainImage: null,
    imageParts: [],
  });
  const [editorialSystemIdInfo, setEditorialSystemIdInfo] = useState(null);
  const [displayDeleteQuestionModal, setDisplayDeleteQuestionModal] =
    useState(false);
  const [displayDeleteVideoModal, setDisplayDeleteVideoModal] = useState(false);
  const [achievementVideoDetail, setAchievementVideoDetail] = useState(null);
  const [lectureSectionDetail, setLectureSectionDetail] = useState(null);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const videoRef = useRef(null);
  const pendingSeekRef = useRef(null);
  const [videoTab, setVideoTab] = useState("mp4");
  const [videoError, setVideoError] = useState(false);
  const row = props.editRow.content;
  const cropId = props.selectedCropId;
  const correct =
    answerOverride != null
      ? answerOverride
      : row
      ? row[6].content
      : cropIdDetails
      ? cropIdDetails.AnswerOption
      : "";
  const pJWT = sessionStorage.getItem("jwtP");
  // Metadata shown next to the DEV/PROD marks. The image responses don't carry
  // per-environment values yet, so devMeta/prodMeta both fall back to the report's
  // values for now; when the API exposes them, point devMeta at imageUrl.* and
  // prodMeta at prodImageUrl.* — the layout below stays the same.
  const reportMeta = {
    bookSectionCropId: row ? row[3]?.content : cropId,
    answerOption: correct,
    videoUrl: row ? row[7]?.content : cropIdDetails?.AnswerVideoPath,
  };
  const devMeta = reportMeta;
  const prodMeta = reportMeta;
  const openVideoUrl = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const renderEnvMeta = (meta) => (
    <div style={styles.envMeta}>
      <span style={styles.metaItem}>
        <span style={styles.metaKey}>CropId:</span>
        {meta.bookSectionCropId != null ? meta.bookSectionCropId : "-"}
      </span>
      <span style={styles.metaItem}>
        <span style={styles.metaKey}>Cevap:</span>
        {meta.answerOption || "-"}
      </span>
      {meta.videoUrl ? (
        <PlayCircleFilledIcon
          titleAccess="Videoyu yeni sekmede aç"
          onClick={() => openVideoUrl(meta.videoUrl)}
          style={styles.videoIcon}
        />
      ) : null}
    </div>
  );
  const getDetails = async () => {
    let res = await getReportsDetails(row[3].content, props.user.Token);
    if (res.status === 200) {
      setDetails(res.data);
    }
  };
  const getDetailsNEW = async () => {
    let res = await getReportsDetails(cropId, props.user.Token);
    if (res.status === 200) {
      setDetails(res.data);
    }
  };
  const deleteVideoReq = async (data) => {
    const resDev = await deleteVideo(data, props.user.Token);
    const resProd = await deleteVideoAdmin(data, pJWT);
    if (resDev.status == 200) {
      if (resDev) {
        toast.success("Video Deleted Successfully on Dev");
      } else {
        toast.error("Video could not found on Dev");
      }
    } else toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
    if (resProd.status == 200) {
      if (resProd) {
        toast.success("Video Deleted Successfully on Prod");
      } else {
        toast.error("Video could not found on Prod");
      }
    } else if (resProd.status == 401) {
      toast.error("Lütfen Tekrar Giriş Yapınız");
    } else toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
  };
  const deleteQuestionReq = async (data) => {
    const resDev = await deleteQuestion(data, props.user.Token);
    const resProd = await deleteQuestionAdmin(data, pJWT);
    if (resDev.status == 200) {
      if (resDev) {
        toast.success("Question Deleted Successfully on Dev");
      } else {
        toast.error("Question could not found on Dev");
      }
    } else toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
    if (resProd.status == 200) {
      if (resProd) {
        toast.success("Question Deleted Successfully on Prod");
      } else {
        toast.error("Question could not found on Prod");
      }
    } else if (resProd.status == 401) {
      toast.error("Lütfen Tekrar Giriş Yapınız");
    } else toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
  };
  const getCropPage = async () => {
    let res = await cropPage(Number(cropId), props.user.Token);
    if (res.status === 200) {
      setCropIdDetails(res.data);
    } else {
      props.modalControl(false);
    }
  };
  useEffect(() => {
    if (cropId) {
      setCropIdDetails([]);
      setDetails([]);
      getCropPage();
      getDetailsNEW();
    }
  }, [cropId]);
  const getImageUrl = async (share) => {
    const param = {
      BookSectionId: row[4].content,
      QuestionNumber: row[5].content,
    };
    let res = await getImageUrlR(param, props.user.Token);
    if (res.status === 200) {
      let url = "https://product.pakodemy.com/share/index.htm?q=";
      if (share) {
        let q = res.data.ImageUrl.substring(
          res.data.ImageUrl.indexOf("crops") + 6
        );
        const part = res.data.ImagePartUrls[0];
        if (part) {
          q += `__${part.substring(part.indexOf("crops") + 6)}`;
        }
        url = url + q;
      } else {
        url = res.data.ImageUrl;
      }
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };
  const getImageUrlNEW = async (share) => {
    const param = {
      BookSectionId: cropIdDetails.BookSectionId,
      QuestionNumber: cropIdDetails.QuestionNumber,
    };
    let res = await getImageUrlR(param, props.user.Token);
    if (res.status === 200) {
      let url = "https://product.pakodemy.com/share/index.htm?q=";
      if (share) {
        let q = res.data.ImageUrl.substring(
          res.data.ImageUrl.indexOf("crops") + 6
        );
        const part = res.data.ImagePartUrls[0];
        if (part) {
          q += `__${part.substring(part.indexOf("crops") + 6)}`;
        }
        url = url + q;
      } else {
        url = res.data.ImageUrl;
      }
      const newWindow = window.open(url, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };
  const fetchImageUrl = async () => {
    let param;
    if (row) {
      param = {
        BookSectionId: row[4].content,
        QuestionNumber: row[5].content,
      };
    } else if (cropId && cropIdDetails && cropIdDetails.BookSectionId) {
      param = {
        BookSectionId: cropIdDetails.BookSectionId,
        QuestionNumber: cropIdDetails.QuestionNumber,
      };
    } else {
      return;
    }

    try {
      const [devRes, prodRes] = await Promise.all([
        getImageUrlR(param, props.user.Token),
        pJWT ? getImageUrlRProd(param, pJWT) : Promise.resolve(null),
      ]);
      if (devRes && devRes.status === 200) {
        const { ImageUrl, ImagePartUrls, RowStatus } = devRes.data;
        setImageUrl({
          mainImage: ImageUrl,
          imageParts: ImagePartUrls || [],
          RowStatus: RowStatus,
        });
      }
      if (prodRes && prodRes.status === 200) {
        const { ImageUrl, ImagePartUrls } = prodRes.data;
        setProdImageUrl({
          mainImage: ImageUrl,
          imageParts: ImagePartUrls || [],
        });
      } else {
        setProdImageUrl({ mainImage: null, imageParts: [] });
      }
    } catch (error) {
      console.error("Error fetching image URL:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchEditorialSystemId = async () => {
    let param;
    if (row) {
      param = {
        BookSectionId: row[4].content,
      };
    } else if (cropId && cropIdDetails && cropIdDetails.BookSectionId) {
      param = {
        BookSectionId: cropIdDetails.BookSectionId,
      };
    } else {
      return;
    }

    try {
      const res = await getEditorialSystemId(
        param.BookSectionId,
        props.user.Token
      );
      if (res.status === 200) {
        setEditorialSystemIdInfo(res.data.ResponseData);
      }
    } catch (error) {
      console.error("Error fetching image URL:", error);
    }
  };
  useEffect(() => {
    if (!props.isOpen) return;
    setImageUrl({ mainImage: null, imageParts: [], RowStatus: false });
    setProdImageUrl({ mainImage: null, imageParts: [] });
    setIsLoading(true);
    fetchImageUrl();
    fetchEditorialSystemId();
  }, [props.isOpen, cropId, cropIdDetails, row, props.user.Token]);

  useEffect(() => {
    if (!props.isOpen) {
      setAchievementVideoDetail(null);
      setLectureSectionDetail(null);
      setSelectedReportId(null);
      return;
    }
    setAchievementVideoDetail(null);
    setLectureSectionDetail(null);
    setSelectedReportId(null);
    if (props.reportContentType === 3 && row) {
      getAchievementVideoDetail(row[3].content, props.user.Token).then((res) => {
        if (res?.status === 200) {
          setAchievementVideoDetail(res.data.ResponseData);
        }
      });
    }
    if (props.reportContentType === 4 && row) {
      getLectureSectionDetail(row[3].content, props.user.Token).then((res) => {
        if (res?.status === 200) {
          setLectureSectionDetail(res.data.ResponseData);
        }
      });
    }
  }, [props.isOpen, row]);

  // Reset the answer-change confirmation + optimistic answer override whenever the
  // dialog opens or closes, so a pending "are you sure" box (and its pending option)
  // never leaks into the next item the dialog is opened for.
  useEffect(() => {
    setShowConfirm(false);
    setAnswerOverride(null);
    setAnswerSubmitting(false);
    option = "";
  }, [props.isOpen]);

  const seekVideo = (seconds) => {
    if (videoRef.current) {
      videoRef.current.currentTime = Math.max(0, seconds - 5);
      videoRef.current.play();
    }
  };

  // Switch between the MP4 and HLS sources while keeping the current
  // position/play-state, since both feeds share the same single <video>.
  const switchVideoTab = (tab) => {
    if (tab === videoTab || !achievementVideoDetail) return;
    if (videoRef.current) {
      pendingSeekRef.current = {
        time: videoRef.current.currentTime,
        playing: !videoRef.current.paused,
      };
    }
    setVideoError(false);
    setVideoTab(tab);
  };

  // Reset to the MP4 tab whenever a different video is loaded into the dialog.
  useEffect(() => {
    setVideoTab("mp4");
    setVideoError(false);
    pendingSeekRef.current = null;
  }, [achievementVideoDetail?.AchievementVideoId]);

  const deleteAchievementVideoReq = async () => {
    const res = await removeContent(achievementVideoDetail.AchievementVideoId, ReportContentType.AchievementVideo, props.user.Token);
    if (res.status === 200) {
      toast.success("Video Deleted Successfully");
    } else {
      toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
    }
    setDisplayDeleteVideoModal(false);
  };

  const deleteLectureSectionReq = async () => {
    const res = await removeContent(lectureSectionDetail.LectureId, ReportContentType.LectureSection, props.user.Token);
    if (res.status === 200) {
      toast.success("Lecture Section Deleted Successfully");
    } else {
      toast.error("Bir hata oluştu lütfen tekrar deneyiniz");
    }
    setDisplayDeleteVideoModal(false);
  };

  useEffect(() => {
    if (row) {
      setDetails([]);
      getDetails();
    }
  }, [row]);

  const onClickAnswerChange = (r, opt) => {
    option = opt;
    setShowConfirm(true);
  };
  const openVideo = () => {
    const url = row[7].content;
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const openVideoNEW = () => {
    const url = cropIdDetails.AnswerVideoPath;
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const handleClose = () => {
    props.onClose();
    setImageUrl({ mainImage: null, imageParts: [] });
    setProdImageUrl({ mainImage: null, imageParts: [] });
  };

  // ─── Derived header values ──────────────────────────────────────────────────
  const isAchievementVideo = props.reportContentType === ReportContentType.AchievementVideo;
  const isLecture = props.reportContentType === ReportContentType.LectureSection;
  const headerTitle = isAchievementVideo
    ? "Kazanım video raporu"
    : isLecture
    ? "Konu kartı raporu"
    : "Soru raporu";
  const qNo = row ? row[5]?.content : cropIdDetails?.QuestionNumber;
  const sectionId = row ? row[4]?.content : cropIdDetails?.BookSectionId;
  const reportCount = row ? row[0]?.content : null;
  const statusVal = row ? row[8]?.content : cropIdDetails ? cropIdDetails.Status : null;
  const headerSub = [
    qNo != null ? `Soru ${qNo}` : null,
    sectionId != null ? `BookSectionId #${sectionId}` : null,
    reportCount != null ? `${reportCount} rapor` : null,
  ]
    .filter(Boolean)
    .join("  ·  ");

  // ─── Render helpers ─────────────────────────────────────────────────────────
  const renderEnvColumn = (label, color, meta, img) => (
    <div>
      <div style={styles.envHeaderRow}>
        <span style={{ ...styles.envBadge, backgroundColor: color }}>{label}</span>
        {renderEnvMeta(meta)}
      </div>
      <div style={styles.imageFrame}>
        {img.mainImage ? (
          <>
            <img
              src={img.mainImage}
              alt={label}
              style={{ maxWidth: "100%", maxHeight: 300, objectFit: "contain" }}
            />
            {img.imageParts &&
              img.imageParts.length > 0 &&
              img.imageParts.map((partUrl, index) => (
                <img
                  key={index}
                  src={partUrl}
                  alt={`${label} ${index + 1}`}
                  style={{ maxWidth: "100%", maxHeight: 300, objectFit: "contain" }}
                />
              ))}
          </>
        ) : (
          <div style={styles.envEmpty}>Görsel bulunamadı</div>
        )}
      </div>
    </div>
  );

  const renderReports = (list, clickable) => {
    const arr = list || [];
    return (
      <>
        <div style={styles.reportsHeader}>
          Kullanıcı raporları{" "}
          <span style={{ color: FB.textMuted, fontWeight: 400 }}>· {arr.length}</span>
        </div>
        {arr.length === 0 ? (
          <div style={styles.emptyReports}>Kullanıcı raporu yok.</div>
        ) : (
          <div style={styles.reportsList}>
            {arr.map((item, i) => {
              const reasons = cleanReasons(item.Description1);
              const dateText = item.CreatedDate
                ? fmtDate(item.CreatedDate)
                : item.ReportTime || "";
              const last = i === arr.length - 1;
              const isSel = clickable && selectedReportId === item.ReportId;
              return (
                <div
                  key={i}
                  onClick={
                    clickable
                      ? () => {
                          setSelectedReportId(item.ReportId);
                          seekVideo(item.ReportSecond);
                        }
                      : undefined
                  }
                  style={{
                    ...styles.reportRow,
                    ...(last ? { borderBottom: "none" } : {}),
                    ...(clickable ? { cursor: "pointer" } : {}),
                    ...(isSel ? { background: FB.accentSoft } : {}),
                  }}
                >
                  <div style={styles.avatar}>{String(item.UserId).slice(-4)}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={styles.reasonChips}>
                      {reasons.length ? (
                        reasons.map((r, ri) => (
                          <span key={ri} style={styles.reasonChip}>
                            {r}
                          </span>
                        ))
                      ) : (
                        <span style={{ fontSize: 12, color: FB.textMuted }}>—</span>
                      )}
                    </div>
                    {item.Description2 ? (
                      <div style={styles.reportComment}>{item.Description2}</div>
                    ) : null}
                  </div>
                  <div style={styles.reportDate}>{dateText}</div>
                </div>
              );
            })}
          </div>
        )}
      </>
    );
  };

  const statusBadge =
    statusVal == null ? null : Number(statusVal) === 0 ? (
      <span style={{ ...styles.statusBadge, background: FB.openSoft, color: FB.open, border: `1px solid ${FB.openBorder}` }}>
        Açık
      </span>
    ) : (
      <span style={{ ...styles.statusBadge, background: FB.doneSoft, color: FB.done, border: `1px solid ${FB.doneBorder}` }}>
        Çözülen
      </span>
    );

  const hasVideo =
    (row && row[7] && row[7].content) ||
    (cropIdDetails && cropIdDetails.AnswerVideoPath);

  return (
    <Dialog id={props.id} open={props.isOpen} onClose={handleClose}>
      {displayDeleteQuestionModal && (
        <Dialog open={displayDeleteQuestionModal} onClose={() => setDisplayDeleteQuestionModal(false)}>
          <div style={styles.deleteModal}>
            <p style={styles.deleteText}>Artık bu soruyu kullanıcılar göremeyecek.</p>
            <p style={styles.deleteText}>Silmek istediğine emin misin?</p>
            <div style={styles.deleteBtns}>
              <button
                style={dangerBtn}
                onClick={() => {
                  deleteQuestionReq(cropId || row[4].content);
                  setDisplayDeleteQuestionModal(false);
                }}
              >
                Sil
              </button>
              <button style={baseBtn} onClick={() => setDisplayDeleteQuestionModal(false)}>
                Vazgeç
              </button>
            </div>
          </div>
        </Dialog>
      )}
      {displayDeleteVideoModal && (
        <Dialog open={displayDeleteVideoModal} onClose={() => setDisplayDeleteVideoModal(false)}>
          <div style={styles.deleteModal}>
            <p style={styles.deleteText}>Artık bu sorunun videosunu kullanıcılar göremeyecek.</p>
            <p style={styles.deleteText}>Silmek istediğine emin misin?</p>
            <div style={styles.deleteBtns}>
              <button
                style={dangerBtn}
                onClick={() => {
                  if (props.reportContentType === 3) {
                    deleteAchievementVideoReq();
                  } else if (props.reportContentType === 4) {
                    deleteLectureSectionReq();
                  } else {
                    deleteVideoReq(cropId || row[4].content);
                    setDisplayDeleteVideoModal(false);
                  }
                }}
              >
                Sil
              </button>
              <button style={baseBtn} onClick={() => setDisplayDeleteVideoModal(false)}>
                Vazgeç
              </button>
            </div>
          </div>
        </Dialog>
      )}

      <div style={styles.modal}>
        {/* Header */}
        <div style={styles.header}>
          <div>
            <div style={styles.headerTitle}>{headerTitle}</div>
            {headerSub ? <div style={styles.headerSub}>{headerSub}</div> : null}
          </div>
          <div style={styles.headerRight}>
            {statusBadge}
            <button style={styles.closeBtn} aria-label="Kapat" onClick={handleClose}>
              <CloseIcon style={{ fontSize: 18 }} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div style={styles.body}>
          {isAchievementVideo ? (
            achievementVideoDetail ? (
              <>
                <div style={styles.videoTabBar}>
                  <button
                    type="button"
                    onClick={() => switchVideoTab("mp4")}
                    style={videoTab === "mp4" ? styles.videoTabActive : styles.videoTab}
                  >
                    MP4
                  </button>
                  <button
                    type="button"
                    disabled={!achievementVideoDetail.VideoHlsUrl}
                    onClick={() => switchVideoTab("hls")}
                    title={achievementVideoDetail.VideoHlsUrl ? "HLS" : "Bu video için HLS mevcut değil"}
                    style={
                      !achievementVideoDetail.VideoHlsUrl
                        ? styles.videoTabDisabled
                        : videoTab === "hls"
                        ? styles.videoTabActive
                        : styles.videoTab
                    }
                  >
                    HLS
                  </button>
                </div>
                <video
                  key={videoTab}
                  ref={videoRef}
                  src={
                    videoTab === "hls" && achievementVideoDetail.VideoHlsUrl
                      ? achievementVideoDetail.VideoHlsUrl
                      : achievementVideoDetail.VideoUrl
                  }
                  controls
                  onError={() => setVideoError(true)}
                  onLoadedMetadata={() => {
                    setVideoError(false);
                    const pending = pendingSeekRef.current;
                    if (pending && videoRef.current) {
                      videoRef.current.currentTime = pending.time;
                      if (pending.playing) {
                        videoRef.current.play().catch(() => {});
                      }
                      pendingSeekRef.current = null;
                    }
                  }}
                  style={{ width: "100%", maxHeight: 420, borderRadius: 8, background: "#000" }}
                />
                {videoTab === "hls" && videoError && (
                  <div style={{ color: FB.danger, fontSize: 12, padding: "6px 2px" }}>
                    HLS bu tarayıcıda oynatılamadı. (HLS yalnızca Safari'de yerel olarak desteklenir.)
                  </div>
                )}
                <div style={styles.toolbar}>
                  <button style={primaryBtn} onClick={() => props.markAsDone(row)}>
                    <CheckCircleIcon style={{ fontSize: 18 }} /> Tamamla
                  </button>
                  {achievementVideoDetail?.RowStatus && (
                    <button style={dangerBtn} onClick={() => setDisplayDeleteVideoModal(true)}>
                      <DeleteOutlineIcon style={{ fontSize: 18 }} /> Videoyu sil
                    </button>
                  )}
                </div>
                {renderReports(achievementVideoDetail.Reports, true)}
              </>
            ) : (
              <div style={styles.center}>
                <CircularProgress style={{ color: FB.accent }} />
              </div>
            )
          ) : isLecture ? (
            lectureSectionDetail ? (
              <>
                <div style={styles.imageFrame}>
                  <img
                    src={lectureSectionDetail.ImageUrl}
                    alt="Konu kartı"
                    style={{ maxWidth: "100%", maxHeight: 420, objectFit: "contain" }}
                  />
                </div>
                <div style={styles.toolbar}>
                  <button style={primaryBtn} onClick={() => props.markAsDone(row)}>
                    <CheckCircleIcon style={{ fontSize: 18 }} /> Tamamla
                  </button>
                  {lectureSectionDetail?.RowStatus && (
                    <button style={dangerBtn} onClick={() => setDisplayDeleteVideoModal(true)}>
                      <DeleteOutlineIcon style={{ fontSize: 18 }} /> Konu kartını sil
                    </button>
                  )}
                </div>
                {renderReports(lectureSectionDetail.Reports, false)}
              </>
            ) : (
              <div style={styles.center}>
                <CircularProgress style={{ color: FB.accent }} />
              </div>
            )
          ) : (
            <>
              {isLoading ? (
                <div style={styles.center}>
                  <CircularProgress style={{ color: FB.accent }} />
                </div>
              ) : (
                <div style={styles.compareGrid}>
                  {renderEnvColumn("Dev", FB.dev, devMeta, imageUrl)}
                  {renderEnvColumn("Prod", FB.prod, prodMeta, prodImageUrl)}
                </div>
              )}

              {/* Answer */}
              <div style={styles.sectionCard}>
                <div style={styles.sectionLabel}>
                  <span>Doğru cevap</span>
                  <span style={{ color: FB.textMuted }}>Değiştirmek için bir seçenek seçin</span>
                </div>
                <div style={styles.ansRow}>
                  {["A", "B", "C", "D", "E"].map((opt) => (
                    <button
                      key={opt}
                      disabled={answerSubmitting}
                      onClick={() => onClickAnswerChange(row, opt)}
                      style={ansPill(correct === opt, showConfirm && option === opt)}
                    >
                      {opt}
                    </button>
                  ))}
                </div>
                {showConfirm && (
                  <div style={styles.confirmBox}>
                    <div style={styles.confirmText}>
                      {answerSubmitting
                        ? "Cevap değiştiriliyor…"
                        : "Cevap değiştirmeyi onaylıyor musun?"}
                    </div>
                    <div style={styles.confirmBtns}>
                      <button
                         style={{
                          ...baseBtn,
                          ...(answerSubmitting ? { opacity: 0.6, cursor: "default" } : {}),
                        }}
                        disabled={answerSubmitting}
                        onClick={() => {
                          option = "";
                          setShowConfirm(false);
                        }}
                      >
                        İptal
                      </button>
                      <button
                        style={{ ...primaryBtn, minWidth: 96, justifyContent: "center" }}
                        disabled={answerSubmitting}
                        onClick={async () => {
                          const chosen = option;
                          setAnswerSubmitting(true);
                          try {
                            let ok = false;
                            if (cropId) {
                              ok = await props.onClickAnswerChangeNEW(cropIdDetails, chosen);
                            } else if (row) {
                              ok = await props.onClickAnswerChange(row, chosen);
                            } else {
                              return;
                            }
                            if (ok) {
                              setAnswerOverride(chosen);
                            }
                            setShowConfirm(false);
                            option = "";
                          } finally {
                            setAnswerSubmitting(false);
                          }
                        }}
                      >
                        {answerSubmitting ? (
                          <CircularProgress size={16} style={{ color: FB.done }} />
                        ) : (
                          "Değiştir"
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Actions */}
              <div style={styles.toolbar}>
                <button
                  style={primaryBtn}
                  onClick={() => {
                    if (cropId) {
                      props.markAsDoneNEW(cropIdDetails);
                    } else if (row) {
                      props.markAsDone(row);
                    }
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: 18 }} /> Tamamla
                </button>
                {editorialSystemIdInfo === EditorialSystemId.CropPage && (
                  <button
                    style={baseBtn}
                    onClick={() => {
                      if (cropId) {
                        props.rowClickNEW(cropIdDetails);
                      } else if (row) {
                        props.rowClick(row);
                      }
                    }}
                  >
                    <CropIcon style={{ fontSize: 18 }} /> Crop sayfası
                  </button>
                )}
                <button
                  style={baseBtn}
                  onClick={() => {
                    if (cropId) {
                      getImageUrlNEW(true);
                    } else if (row) {
                      getImageUrl(true);
                    }
                  }}
                >
                  <ShareIcon style={{ fontSize: 18 }} /> Paylaş
                </button>
                {imageUrl.RowStatus ? (
                  <span style={styles.dangerGroup}>
                    {hasVideo && (
                      <button style={dangerBtn} onClick={() => setDisplayDeleteVideoModal(true)}>
                        <DeleteOutlineIcon style={{ fontSize: 18 }} /> Videoyu sil
                      </button>
                    )}
                    <button style={dangerBtn} onClick={() => setDisplayDeleteQuestionModal(true)}>
                      <DeleteOutlineIcon style={{ fontSize: 18 }} /> Soruyu sil
                    </button>
                  </span>
                ) : (
                  <span style={styles.deletedNote}>Bu soru silinmiştir</span>
                )}
              </div>

              {renderReports(details, false)}
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
}

const styles = {
  modal: { width: "100%" },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "16px 20px",
    borderBottom: `1px solid ${FB.border}`,
  },
  headerTitle: { fontSize: 17, fontWeight: 600, color: FB.text },
  headerSub: { fontSize: 12, color: FB.textMuted, marginTop: 2 },
  headerRight: { display: "flex", alignItems: "center", gap: 10 },
  statusBadge: {
    fontSize: 12,
    fontWeight: 500,
    padding: "3px 10px",
    borderRadius: 999,
  },
  closeBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: 8,
    border: `1px solid ${FB.border}`,
    background: FB.surface,
    color: FB.textSecondary,
    cursor: "pointer",
  },
  body: { padding: 20, maxHeight: "78vh", overflowY: "auto" },
  center: { display: "flex", justifyContent: "center", padding: 30 },

  compareGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 },
  envHeaderRow: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 8 },
  envBadge: {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    color: "#fff",
    letterSpacing: 0.4,
  },
  imageFrame: {
    border: `1px solid ${FB.border}`,
    borderRadius: 10,
    background: FB.surfaceAlt,
    padding: 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    minHeight: 120,
  },
  envEmpty: { color: FB.textMuted, fontSize: 13, padding: "28px 8px", textAlign: "center" },
  envMeta: { display: "flex", alignItems: "center", gap: 10, fontSize: 12, color: FB.textSecondary, flexWrap: "wrap" },
  metaItem: { whiteSpace: "nowrap" },
  metaKey: { color: FB.textMuted, marginRight: 4 },
  videoIcon: { cursor: "pointer", color: FB.accent, fontSize: 20 },

  sectionCard: { border: `1px solid ${FB.border}`, borderRadius: 10, padding: 14, marginBottom: 16 },
  sectionLabel: {
    fontSize: 13,
    color: FB.textSecondary,
    marginBottom: 10,
    display: "flex",
    justifyContent: "space-between",
    gap: 10,
    flexWrap: "wrap",
  },
  ansRow: { display: "flex", gap: 8, flexWrap: "wrap" },
  confirmBox: { marginTop: 12, padding: 12, borderRadius: 10, background: FB.openSoft, border: `1px solid ${FB.openBorder}` },
  confirmText: { fontSize: 13, color: FB.open, marginBottom: 10, textAlign: "center" },
  confirmBtns: { display: "flex", justifyContent: "center", gap: 10 },

  toolbar: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 18 },
  dangerGroup: { marginLeft: "auto", display: "flex", gap: 8, flexWrap: "wrap" },
  deletedNote: { marginLeft: "auto", color: FB.danger, fontSize: 13 },

  reportsHeader: { fontSize: 13, fontWeight: 600, color: FB.text, marginBottom: 8 },
  reportsList: { border: `1px solid ${FB.border}`, borderRadius: 10, overflow: "hidden" },
  reportRow: { display: "flex", alignItems: "flex-start", gap: 12, padding: "10px 12px", borderBottom: `1px solid ${FB.border}` },
  avatar: {
    width: 34,
    height: 34,
    borderRadius: "50%",
    background: FB.accentSoft,
    color: FB.accent,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 11,
    fontWeight: 600,
    flexShrink: 0,
  },
  reasonChips: { display: "flex", gap: 6, flexWrap: "wrap" },
  reasonChip: {
    fontSize: 12,
    padding: "2px 8px",
    borderRadius: 999,
    background: FB.accentSoft,
    color: FB.accent,
    border: `1px solid ${FB.accentBorder}`,
  },
  reportComment: { fontSize: 12, color: FB.textSecondary, marginTop: 3 },
  reportDate: { fontSize: 12, color: FB.textMuted, whiteSpace: "nowrap", marginLeft: "auto" },
  emptyReports: { padding: 20, textAlign: "center", color: FB.textMuted, fontSize: 13 },

  deleteModal: { padding: 24, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 },
  deleteText: { fontSize: 14, color: FB.text, margin: 0, textAlign: "center" },
  deleteBtns: { display: "flex", gap: 10, marginTop: 12 },

  videoTabBar: { display: "flex", gap: 4, marginBottom: 8 },
  videoTab: {
    padding: "6px 16px",
    border: "none",
    borderBottom: "2px solid transparent",
    background: "transparent",
    cursor: "pointer",
    fontSize: 14,
    color: FB.textSecondary,
  },
  videoTabActive: {
    padding: "6px 16px",
    border: "none",
    borderBottom: `2px solid ${FB.accent}`,
    background: "transparent",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    color: FB.accent,
  },
  videoTabDisabled: {
    padding: "6px 16px",
    border: "none",
    borderBottom: "2px solid transparent",
    background: "transparent",
    cursor: "not-allowed",
    fontSize: 14,
    color: "#bdbdbd",
  },
};
export default ReportDialog;
